import { Injectable } from "@angular/core";

import { FirebaseTalk } from "../../models/firebase-talk";

import { AngularFireDatabase } from "angularfire2/database";
import {
  AngularFireStorage,
  AngularFireUploadTask,
  AngularFireStorageReference
} from "angularfire2/storage";
import { Observable } from "rxjs/Observable";

@Injectable()
export class AngularFireProvider {
  private prefix: string = "";
  private CHAT_TALK_LOAD_LIMIT_NUM: number = 200;

  constructor(
    private afStorage: AngularFireStorage,
    private afDB: AngularFireDatabase
  ) {}

  setPrefix(prefix: string): void {
    this.prefix = prefix;
  }

  fetchChatTalksArray(roomId): Observable<FirebaseTalk[]> {
    console.log(this.createRoomPath(roomId));
    return this.afDB
      .list(this.createRoomPath(roomId), ref =>
        ref.limitToLast(this.CHAT_TALK_LOAD_LIMIT_NUM)
      )
      .valueChanges()
      .map(talks => talks.map(talk => new FirebaseTalk(talk)));
  }

  readFile(callback: Function, file: Blob, order?: number) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const file_base64 = reader.result.split(",");
      callback(file_base64[1], order);
    };
  }

  uploadChatImage(path: string, blobImage: Blob): AngularFireUploadTask {
    return this.uploadImage(path, blobImage);
  }

  getReference(imagePath: string): AngularFireStorageReference {
    return this.afStorage.ref(imagePath);
  }

  uploadImage(path: string, blobImage: Blob): AngularFireUploadTask {
    return this.afStorage.upload(path, blobImage);
  }

  createProfileImagePath(
    userId: number,
    order: number
  ): string {
    return (
      this.prefix +
      "/images/profile/user-" +
      userId +
      "/" +
      new Date().getTime()
    );
  }

  createRoomImagePath(
    uploadUserId: number,
    talkLength: number,
    userIds: number[]
  ): string {
    const now: Date = new Date();
    return (
      this.prefix +
      "/images/rooms/" +
      userIds.sort().join("-") +
      "/" +
      uploadUserId +
      "-" +
      talkLength +
      "-" +
      now.getTime()
    );
  }

  createAgeVerificationImagePath(userId: number): string {
    return this.prefix + "/images/age-verification/user-" + userId + ".png";
  }

  createIncomeProofImagePath(userId: number): any {
    return this.prefix + "/images/income-proof/user-" + userId + ".png";
  }

  createAssetProofImagePath(userId: number): any {
    return this.prefix + "/images/asset-proof/user-" + userId + ".png";
  }

  private createRoomPath(roomID: number): string {
    return this.prefix + "/rooms/" + roomID;
  }
}



// WEBPACK FOOTER //
// ./src/providers/firebase/angularfire.ts